export const editorOptions = {
  theme: 'vs-dark',
  language: 'sql',
  placeholder: 'Start writing SQL Query',
  automaticLayout: true,
  autoClosingBrackets: 'always',
  autoIndent: 'full',
  formatOnPaste: true,
  suggestOnTriggerCharacters: true,
  matchBrackets: true,
  highlightActiveIndentGuide: true,
  acceptSuggestionOnEnter: 'smart',
  quickSuggestions: { other: true, comments: false, strings: false },
  enableSuggestions: true,
  showUnused: true,
  minimap: { enabled: true },
  wordWrap: 'on',
  fontSize: 16,
};
